import { KEY_COMPONENT_NAME } from './variable';
export default {
  name: KEY_COMPONENT_NAME,
  echart: ['common', 'map', 'map3D', 'newMap3D', 'worldMap', 'pictorialbar', 'wordcloud', 'scatter', 'bar', 'line', 'pie', 'gauge', 'funnel', 'radar', 'rectangle', 'pieCircle', 'pieCircleIndex', 'helmetBar', 'horizontalBar', 'mixBar', 'mixBarNew', 'bar3D', 'prism3D', 'periodBar']
};
